import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _css;
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable */

// TODO: https://product-fabric.atlassian.net/browse/DSP-4290
import { css } from '@emotion/react';
import { B200, B75, N40A, N50A, N60A } from '@atlaskit/theme/colors';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export var searchMatchClass = 'search-match';
export var selectedSearchMatchClass = 'selected-search-match';
export var findReplaceStyles = css((_css = {}, _defineProperty(_css, ".".concat(searchMatchClass), getBooleanFF('platform.editor.a11y-find-replace') ? {
  borderRadius: '3px',
  backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
  boxShadow: "var(--ds-shadow-raised, ".concat("0 1px 1px 0 ".concat(N50A, ", 0 0 1px 0 ").concat(N60A), ")") + ', inset 0 0 0 1px ' + "var(--ds-border-input, ".concat("".concat(N40A), ")")
} : {
  backgroundColor: B75
}), _defineProperty(_css, ".".concat(selectedSearchMatchClass), getBooleanFF('platform.editor.a11y-find-replace') ? {
  backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
} : {
  backgroundColor: B200,
  color: 'white'
}), _css));